var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmpty(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 400.19 356.86",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;}.cls-2,.cls-3{fill:#173d7a;}.cls-2{opacity:0.5;}.cls-4{fill:#396caa;}.cls-5{fill:#274f89;}.cls-6{fill:#d4ecff;}.cls-7{fill:#fff;}.cls-8{fill:#5793ce;}.cls-9{fill:#ff2c9c;}.cls-10{opacity:0.3;}.cls-11{clip-path:url(#clip-path);}.cls-12{fill:#79b1e0;}.cls-13{fill:#d3008d;}.cls-14{fill:#e573b5;}.cls-15{clip-path:url(#clip-path-2);}.cls-16{fill:#b70083;}"), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M327.31,184.36l22.74-92.82L264.14,40.62l49.58-22.86,63.79,24.6s.39,112.4,0,113.53-23.63,38.84-23.63,38.84Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M327.31,184.36l22.74-92.82L264.14,40.62,159.39,79.57l80.38,104.9s66.37,37.82,66,38.95,48.13-28.69,48.13-28.69Z"
  })))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Asset 1") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_\\xCE\\xD3\\xC8_1",
    "data-name": "\\u2014\\xCE\\xD3\\xC8_1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M240.35,311.83,97.59,229.4c-4-2.33-3.53-6.4,1.13-9.1l97.21-56.1c4.67-2.7,11.72-3,15.76-.66L354.46,246c4,2.33,3.53,6.4-1.14,9.1l-97.21,56.1C251.45,313.87,244.39,314.16,240.35,311.83Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M394.46,86.69,245.9.92a6,6,0,0,0-5-.62h0l-.27.1-.07,0-5.37,2.06L240,4.83c0,.09-.05.17-.07.26L215.73,115.23c-1.22,5.51,1.21,12,5.41,14.38l145,83.7-.51,6.15,5.86-2.28c2-.92,3.55-3,4.21-6l24.19-110.14C401.08,95.55,398.66,89.11,394.46,86.69Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M394.46,86.69,245.9.92a6,6,0,0,0-5-.62h0l-.27.1-.07,0-5.37,2.06L240,4.83c0,.09-.05.17-.07.26L224,77.68l72.68,56.63,102.49-41.7A11.5,11.5,0,0,0,394.46,86.69Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M388.86,103.62l11.3-4.82c.21-4.38-1.6-8.9-4.58-11.32L377.68,95Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M360.45,218.87,211.89,133.1c-4.2-2.42-6.63-8.86-5.42-14.37L230.67,8.59c1.21-5.52,5.6-8,9.8-5.59L389,88.77c4.2,2.42,6.63,8.86,5.41,14.37L370.25,213.28C369,218.8,364.65,221.3,360.45,218.87Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M390.45,88.24,241.9,2.48a5.86,5.86,0,0,0-5.85-.26,6.12,6.12,0,0,1,4.42.78L389,88.77c4.2,2.42,6.63,8.86,5.41,14.37L370.25,213.28a8.4,8.4,0,0,1-3.95,5.85c2.5-.55,4.6-2.83,5.37-6.37l24.2-110.14C397.08,97.11,394.66,90.67,390.45,88.24Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M357.23,210.68,217.51,130.05c-3.84-2.22-6.06-8.1-4.95-13.15L234.7,16.11c1.11-5,5.12-7.33,9-5.11L383.38,91.62c3.85,2.22,6.07,8.11,5,13.15L366.2,205.57C365.09,210.61,361.07,212.9,357.23,210.68Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M357.23,210.68,217.51,130.05c-3.84-2.22-6.06-8.1-4.95-13.15L234.7,16.11c1.11-5,5.12-7.33,9-5.11L383.38,91.62c3.85,2.22,6.07,8.11,5,13.15L366.2,205.57C365.09,210.61,361.07,212.9,357.23,210.68Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M358.44,210.18,218.73,129.56c-3.85-2.22-6.06-8.11-5-13.15l22.15-100.8a7.72,7.72,0,0,1,3.52-5.3c-2.22.57-4.05,2.65-4.74,5.8L212.56,116.9c-1.11,5,1.11,10.93,4.95,13.15l139.72,80.63a5.35,5.35,0,0,0,5.44.19A5.59,5.59,0,0,1,358.44,210.18Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M362.5,222.61l-20.31-2.68L211.11,144.25c-4.2-2.43-11.54-2.13-16.4.67l-92.88,53.61-12.28-1.62v7h0c-.08,1.61.84,3.16,2.82,4.3L240.94,294c4.2,2.43,11.54,2.12,16.39-.68l101.16-58.38c2.73-1.58,4.09-3.61,4-5.51h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M264,174.79l-9.32-5.38H152.3l-50.47,29.12-12.28-1.62v7h0c-.08,1.61.84,3.16,2.82,4.3L240.94,294a15.36,15.36,0,0,0,8.46,1.59Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M95,197.63l-5.45-.72v7h0c-.08,1.61.84,3.16,2.82,4.3L95,209.69Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M242.43,294.65a19,19,0,0,0,13.93-.87V278.24H242.43Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M240.94,287,92.38,201.22c-4.2-2.42-3.67-6.66,1.18-9.46l101.15-58.38c4.86-2.81,12.2-3.11,16.4-.68l148.55,85.76c4.21,2.43,3.68,6.67-1.17,9.47L257.33,286.31C252.48,289.11,245.14,289.42,240.94,287Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M358.49,225.39,257.33,283.77c-4.85,2.8-12.19,3.1-16.39.68L92.38,198.68a5.51,5.51,0,0,1-2.61-2.86c-.66,2,.18,4,2.61,5.4L240.94,287c4.2,2.43,11.54,2.12,16.39-.68l101.16-58.38c3.26-1.88,4.56-4.41,3.79-6.61A7.93,7.93,0,0,1,358.49,225.39Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M155.56,172.83,148.84,169c-.54-.31-.47-.86.15-1.22l7.94-4.58a2.3,2.3,0,0,1,2.1-.08l6.72,3.88c.54.31.48.85-.15,1.21l-7.93,4.58A2.35,2.35,0,0,1,155.56,172.83Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M165.94,178.82l-6.72-3.88c-.54-.31-.47-.85.15-1.21l7.94-4.58a2.33,2.33,0,0,1,2.1-.09l6.72,3.88c.54.31.48.86-.15,1.21l-7.93,4.59A2.35,2.35,0,0,1,165.94,178.82Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M176.32,184.82l-6.72-3.89c-.54-.31-.47-.85.15-1.21l7.94-4.58a2.33,2.33,0,0,1,2.1-.09l6.72,3.88c.54.31.48.86-.15,1.22l-7.93,4.58A2.35,2.35,0,0,1,176.32,184.82Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M190.68,179.87,184,176c-.54-.32-.47-.86.15-1.22l6.66-3.84a2.33,2.33,0,0,1,2.1-.09l6.73,3.88c.54.31.47.85-.16,1.21l-6.65,3.85A2.36,2.36,0,0,1,190.68,179.87Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M201.06,185.86,194.34,182c-.54-.31-.47-.86.15-1.22l6.66-3.84a2.33,2.33,0,0,1,2.1-.09l6.73,3.88c.54.31.47.86-.15,1.22l-6.66,3.84A2.36,2.36,0,0,1,201.06,185.86Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M211.44,191.85,204.72,188c-.54-.31-.47-.85.15-1.21l6.66-3.85a2.33,2.33,0,0,1,2.1-.09l6.73,3.88c.54.32.47.86-.15,1.22l-6.66,3.84A2.36,2.36,0,0,1,211.44,191.85Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M221.82,197.85,215.1,194c-.54-.31-.47-.85.15-1.21l6.66-3.85a2.3,2.3,0,0,1,2.1-.08l6.73,3.88c.54.31.47.85-.15,1.21l-6.66,3.85A2.36,2.36,0,0,1,221.82,197.85Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M232.2,203.84,225.48,200c-.54-.31-.47-.86.15-1.22l6.66-3.84a2.33,2.33,0,0,1,2.1-.09l6.73,3.88c.54.31.47.86-.15,1.22l-6.66,3.84A2.36,2.36,0,0,1,232.2,203.84Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M242.58,209.83,235.86,206c-.54-.31-.47-.86.15-1.22l6.66-3.84a2.33,2.33,0,0,1,2.1-.09l6.73,3.88c.54.31.47.86-.15,1.22l-6.66,3.84A2.36,2.36,0,0,1,242.58,209.83Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M253,215.82l-6.72-3.88c-.54-.31-.47-.85.15-1.21l6.66-3.85a2.3,2.3,0,0,1,2.1-.08l6.73,3.88c.54.31.47.85-.15,1.21l-6.66,3.85A2.32,2.32,0,0,1,253,215.82Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M263.34,221.82l-6.72-3.88c-.54-.32-.47-.86.15-1.22l6.66-3.84a2.33,2.33,0,0,1,2.1-.09l6.73,3.88c.54.31.47.85-.15,1.21l-6.66,3.85A2.36,2.36,0,0,1,263.34,221.82Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M273.72,227.81,267,223.93c-.54-.31-.47-.86.15-1.22l6.66-3.84a2.33,2.33,0,0,1,2.1-.09l6.73,3.88c.54.31.47.86-.15,1.22l-6.66,3.84A2.36,2.36,0,0,1,273.72,227.81Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M284.1,233.8l-6.72-3.88c-.54-.31-.47-.85.15-1.21l6.66-3.85a2.33,2.33,0,0,1,2.1-.09l6.73,3.88c.54.32.47.86-.15,1.22l-6.66,3.85A2.35,2.35,0,0,1,284.1,233.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M206,177l-6.72-3.88c-.54-.31-.47-.86.15-1.22l6.66-3.84a2.36,2.36,0,0,1,2.11-.09l6.72,3.88c.54.31.47.86-.15,1.22l-6.66,3.84A2.35,2.35,0,0,1,206,177Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M195.44,171l-6.72-3.88c-.54-.32-.47-.86.15-1.22l6.66-3.84a2.33,2.33,0,0,1,2.1-.09l6.73,3.88c.54.31.47.85-.16,1.21l-6.66,3.85A2.33,2.33,0,0,1,195.44,171Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M184.89,164.85l-14.48-8.35c-.54-.32-.47-.86.15-1.22l6.66-3.84a2.35,2.35,0,0,1,2.11-.09l14.47,8.36c.54.31.48.85-.15,1.21L187,164.77A2.3,2.3,0,0,1,184.89,164.85Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M192.26,157.45l-11.75-6.79c-.53-.31-.47-.85.16-1.21l6.66-3.85a2.33,2.33,0,0,1,2.1-.09l11.75,6.79c.54.31.47.85-.15,1.21l-6.66,3.85A2.35,2.35,0,0,1,192.26,157.45Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M216.35,183l-6.72-3.88c-.54-.31-.47-.85.15-1.21l6.66-3.85a2.36,2.36,0,0,1,2.11-.09l6.72,3.88c.54.32.47.86-.15,1.22l-6.66,3.84A2.35,2.35,0,0,1,216.35,183Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M226.73,189,220,185.13c-.54-.31-.47-.85.15-1.21l6.66-3.85a2.32,2.32,0,0,1,2.11-.08l6.72,3.88c.54.31.47.85-.15,1.21l-6.66,3.85A2.32,2.32,0,0,1,226.73,189Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M237.11,195l-6.72-3.88c-.54-.31-.47-.86.15-1.22l6.66-3.84a2.36,2.36,0,0,1,2.11-.09l6.72,3.88c.54.31.47.86-.15,1.22l-6.66,3.84A2.35,2.35,0,0,1,237.11,195Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M247.49,201l-6.72-3.88c-.54-.31-.47-.86.15-1.22l6.66-3.84a2.36,2.36,0,0,1,2.11-.09l6.72,3.88c.54.31.47.86-.15,1.22l-6.66,3.84A2.35,2.35,0,0,1,247.49,201Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M257.87,207l-6.72-3.88c-.54-.31-.47-.85.15-1.21l6.66-3.85a2.32,2.32,0,0,1,2.11-.08l6.72,3.88c.54.31.47.85-.15,1.21L260,206.91A2.32,2.32,0,0,1,257.87,207Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M268.25,213l-6.72-3.88c-.54-.32-.47-.86.15-1.22l6.66-3.84a2.36,2.36,0,0,1,2.11-.09l6.72,3.88c.54.31.47.85-.15,1.21l-6.66,3.85A2.35,2.35,0,0,1,268.25,213Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M278.63,219l-6.72-3.88c-.54-.31-.47-.86.15-1.22l6.66-3.84a2.36,2.36,0,0,1,2.11-.09l6.72,3.88c.54.31.47.86-.15,1.22l-6.66,3.84A2.35,2.35,0,0,1,278.63,219Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M289,225l-6.72-3.88c-.54-.31-.47-.85.15-1.21L289.1,216a2.36,2.36,0,0,1,2.11-.09l6.72,3.88c.54.32.47.86-.15,1.22l-6.66,3.85A2.38,2.38,0,0,1,289,225Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M299.39,231l-6.72-3.89c-.54-.31-.47-.85.15-1.21l6.66-3.85a2.35,2.35,0,0,1,2.11-.08l6.72,3.88c.54.31.47.85-.15,1.21l-6.66,3.85A2.35,2.35,0,0,1,299.39,231Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M317.85,241.62l-14.67-8.47c-.54-.31-.47-.85.15-1.21l6.66-3.85a2.36,2.36,0,0,1,2.11-.09l14.66,8.47c.54.31.48.86-.15,1.22L320,241.53A2.33,2.33,0,0,1,317.85,241.62Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M338.06,230l-12.38-7.14c-.54-.32-.47-.86.15-1.22l6.66-3.85a2.33,2.33,0,0,1,2.1-.08L347,224.8c.54.32.47.86-.15,1.22l-6.66,3.84A2.33,2.33,0,0,1,338.06,230Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M234.53,181.85,227.81,178c-.54-.31-.47-.86.15-1.22l6.66-3.84a2.35,2.35,0,0,1,2.11-.09l6.72,3.88c.54.31.47.86-.15,1.22l-6.66,3.84A2.36,2.36,0,0,1,234.53,181.85Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M223.89,175.71l-6.72-3.88c-.54-.31-.47-.86.15-1.22l6.66-3.84a2.36,2.36,0,0,1,2.11-.09l6.72,3.88c.54.31.47.86-.15,1.22L226,175.62A2.35,2.35,0,0,1,223.89,175.71Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M213.26,169.57l-6.73-3.89c-.54-.31-.47-.85.15-1.21l6.66-3.85a2.35,2.35,0,0,1,2.11-.08l6.72,3.88c.54.31.47.85-.15,1.21l-6.66,3.85A2.33,2.33,0,0,1,213.26,169.57Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M202.62,163.42l-6.72-3.88c-.54-.31-.48-.85.15-1.21l6.66-3.85a2.33,2.33,0,0,1,2.1-.09l6.72,3.89c.54.31.48.85-.15,1.21l-6.66,3.85A2.3,2.3,0,0,1,202.62,163.42Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M244.91,187.84,238.19,184c-.54-.31-.47-.85.15-1.21L245,178.9a2.35,2.35,0,0,1,2.11-.09l6.72,3.88c.54.32.47.86-.15,1.22L247,187.76A2.38,2.38,0,0,1,244.91,187.84Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M255.29,193.84,248.57,190c-.54-.31-.47-.85.15-1.21l6.66-3.85a2.35,2.35,0,0,1,2.11-.08l6.72,3.88c.54.31.47.85-.15,1.21l-6.66,3.85A2.36,2.36,0,0,1,255.29,193.84Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M265.67,199.83,259,196c-.54-.31-.47-.86.15-1.22l6.66-3.84a2.35,2.35,0,0,1,2.11-.09l6.72,3.88c.54.31.47.86-.15,1.22l-6.66,3.84A2.36,2.36,0,0,1,265.67,199.83Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M276.05,205.82l-6.72-3.88c-.54-.31-.47-.86.15-1.22l6.66-3.84a2.35,2.35,0,0,1,2.11-.09l6.72,3.88c.54.31.47.86-.15,1.22l-6.66,3.84A2.36,2.36,0,0,1,276.05,205.82Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M286.43,211.81l-6.72-3.88c-.54-.31-.47-.85.15-1.21l6.66-3.85a2.32,2.32,0,0,1,2.11-.08l6.72,3.88c.54.31.47.85-.15,1.21l-6.66,3.85A2.32,2.32,0,0,1,286.43,211.81Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M296.81,217.81l-6.72-3.88c-.54-.32-.47-.86.15-1.22l6.66-3.84a2.35,2.35,0,0,1,2.11-.09l6.72,3.88c.54.31.47.85-.15,1.21l-6.66,3.85A2.36,2.36,0,0,1,296.81,217.81Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M307.19,223.8l-6.72-3.88c-.54-.31-.47-.86.15-1.22l6.66-3.84a2.35,2.35,0,0,1,2.11-.09l6.72,3.88c.54.31.47.86-.15,1.22l-6.66,3.84A2.36,2.36,0,0,1,307.19,223.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M317.57,229.79l-6.72-3.88c-.54-.31-.47-.85.15-1.21l6.66-3.85a2.35,2.35,0,0,1,2.11-.09l6.72,3.88c.54.32.47.86-.15,1.22l-6.66,3.85A2.35,2.35,0,0,1,317.57,229.79Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M328,235.79l-6.72-3.88c-.54-.32-.47-.86.15-1.22l6.66-3.85a2.35,2.35,0,0,1,2.11-.08l6.72,3.88c.54.31.47.85-.15,1.21l-6.66,3.85A2.36,2.36,0,0,1,328,235.79Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M229.07,167l-6.73-3.88c-.54-.32-.47-.86.16-1.22l6.66-3.85a2.36,2.36,0,0,1,2.1-.08l6.72,3.88c.54.31.47.85-.15,1.21l-6.66,3.85A2.33,2.33,0,0,1,229.07,167Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M218.74,161.06,212,157.18c-.54-.31-.48-.85.15-1.21l6.66-3.85a2.33,2.33,0,0,1,2.1-.09l6.72,3.89c.54.31.48.85-.15,1.21L220.84,161A2.33,2.33,0,0,1,218.74,161.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M208.41,155.1l-6.72-3.88c-.54-.31-.47-.86.15-1.22l6.66-3.84a2.33,2.33,0,0,1,2.1-.09l6.73,3.88c.54.31.47.86-.16,1.22L210.51,155A2.33,2.33,0,0,1,208.41,155.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M198.08,149.14l-6.72-3.88c-.54-.32-.47-.86.15-1.22l6.66-3.84a2.35,2.35,0,0,1,2.11-.09L207,144c.54.31.47.85-.15,1.21l-6.66,3.85A2.36,2.36,0,0,1,198.08,149.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M208.7,143,202,139.12c-.54-.31-.47-.85.15-1.21l2.2-1.27a2.36,2.36,0,0,1,2.11-.09l6.72,3.88c.54.31.47.86-.15,1.22l-2.2,1.27A2.36,2.36,0,0,1,208.7,143Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M222.18,150.79l-6.72-3.88c-.54-.32-.47-.86.15-1.22l2.2-1.27a2.35,2.35,0,0,1,2.11-.09l6.72,3.88c.54.31.47.86-.15,1.22l-2.2,1.27A2.36,2.36,0,0,1,222.18,150.79Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M232.47,156.73l-6.73-3.89c-.54-.31-.47-.85.15-1.21l2.21-1.27a2.33,2.33,0,0,1,2.1-.09l6.72,3.88c.54.31.48.86-.15,1.22l-2.2,1.27A2.33,2.33,0,0,1,232.47,156.73Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M242.75,162.66,236,158.78c-.54-.31-.47-.85.15-1.21l2.2-1.27a2.36,2.36,0,0,1,2.11-.09l6.72,3.88c.54.31.47.86-.15,1.22l-2.2,1.27A2.32,2.32,0,0,1,242.75,162.66Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M253,168.6l-6.73-3.88c-.54-.31-.47-.85.16-1.21l2.2-1.28a2.33,2.33,0,0,1,2.1-.08l6.72,3.88c.54.31.48.85-.15,1.21l-2.2,1.27A2.33,2.33,0,0,1,253,168.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M310.46,201.75l-6.72-3.88c-.54-.31-.48-.85.15-1.21l2.2-1.27a2.33,2.33,0,0,1,2.1-.09l6.73,3.88c.54.31.47.86-.16,1.22l-2.2,1.27A2.3,2.3,0,0,1,310.46,201.75Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M320.74,207.69,314,203.81c-.54-.31-.47-.85.15-1.21l2.2-1.27a2.36,2.36,0,0,1,2.11-.09l6.72,3.88c.54.31.47.85-.15,1.21l-2.2,1.28A2.38,2.38,0,0,1,320.74,207.69Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M331,213.63l-6.72-3.88c-.54-.31-.48-.86.15-1.22l2.2-1.27a2.32,2.32,0,0,1,2.11-.08l6.72,3.88c.54.31.47.85-.15,1.21l-2.21,1.27A2.33,2.33,0,0,1,331,213.63Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M341.31,219.57l-6.72-3.88c-.54-.31-.47-.86.15-1.22l2.2-1.27a2.36,2.36,0,0,1,2.11-.09l6.72,3.88c.54.32.47.86-.15,1.22l-2.2,1.27A2.35,2.35,0,0,1,341.31,219.57Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M239.45,173l-6.73-3.88c-.54-.31-.47-.86.16-1.22l6.66-3.84a2.33,2.33,0,0,1,2.1-.09l6.72,3.88c.54.31.47.86-.15,1.22l-6.66,3.84A2.33,2.33,0,0,1,239.45,173Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M249.83,179l-6.73-3.88c-.54-.31-.47-.85.16-1.21l6.66-3.85A2.33,2.33,0,0,1,252,170l6.72,3.88c.54.32.47.86-.15,1.22l-6.66,3.84A2.33,2.33,0,0,1,249.83,179Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M260.21,185l-6.73-3.89c-.54-.31-.47-.85.16-1.21l6.66-3.85a2.3,2.3,0,0,1,2.1-.08l6.72,3.88c.54.31.47.85-.15,1.21l-6.66,3.85A2.33,2.33,0,0,1,260.21,185Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M270.59,191l-6.73-3.88c-.54-.31-.47-.86.16-1.22l6.66-3.84a2.33,2.33,0,0,1,2.1-.09l6.72,3.88c.54.31.47.86-.15,1.22l-6.66,3.84A2.33,2.33,0,0,1,270.59,191Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M281,197l-6.73-3.88c-.54-.31-.47-.86.16-1.22l6.66-3.84a2.33,2.33,0,0,1,2.1-.09l6.72,3.88c.54.31.47.86-.15,1.22l-6.66,3.84A2.33,2.33,0,0,1,281,197Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M291.35,203l-6.73-3.88c-.54-.31-.47-.85.16-1.21l6.66-3.85a2.3,2.3,0,0,1,2.1-.08l6.72,3.88c.54.31.47.85-.15,1.21l-6.66,3.85A2.3,2.3,0,0,1,291.35,203Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M301.73,209,295,205.1c-.54-.32-.47-.86.16-1.22l6.66-3.84a2.33,2.33,0,0,1,2.1-.09l6.72,3.88c.54.31.47.85-.15,1.21l-6.66,3.85A2.33,2.33,0,0,1,301.73,209Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M312.11,215l-6.73-3.88c-.54-.31-.47-.86.16-1.22L312.2,206a2.33,2.33,0,0,1,2.1-.09l6.72,3.88c.54.31.47.86-.15,1.22l-6.66,3.84A2.33,2.33,0,0,1,312.11,215Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M322.49,221l-6.73-3.88c-.53-.31-.47-.85.16-1.21l6.66-3.85a2.33,2.33,0,0,1,2.1-.09l6.72,3.88c.54.32.47.86-.15,1.22l-6.66,3.85A2.33,2.33,0,0,1,322.49,221Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M180.1,173.76l-19.79-11.43c-.54-.31-.48-.86.15-1.22l6.66-3.84a2.33,2.33,0,0,1,2.1-.09L189,168.61c.54.31.47.86-.15,1.22l-6.66,3.84A2.36,2.36,0,0,1,180.1,173.76Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M307.62,247.38,287.83,236c-.54-.31-.47-.85.15-1.21l6.66-3.85a2.33,2.33,0,0,1,2.1-.08l19.8,11.43c.54.31.47.85-.15,1.21l-6.66,3.85A2.32,2.32,0,0,1,307.62,247.38Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M266.11,236.65l-6.72-3.88c-.54-.31-.47-.85.15-1.21l7.93-4.58a2.36,2.36,0,0,1,2.11-.09l6.72,3.88c.54.31.47.86-.15,1.22l-7.93,4.58A2.32,2.32,0,0,1,266.11,236.65Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M190.73,193.13,180,186.93c-.54-.31-.47-.86.15-1.22l7.94-4.58a2.33,2.33,0,0,1,2.1-.09l10.75,6.21c.54.31.47.86-.15,1.22l-7.93,4.58A2.32,2.32,0,0,1,190.73,193.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M256.11,230.88l-10.75-6.21c-.54-.31-.47-.85.15-1.21l7.94-4.58a2.33,2.33,0,0,1,2.1-.09L266.3,225c.54.31.47.85-.15,1.21l-7.93,4.58A2.36,2.36,0,0,1,256.11,230.88Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M205.71,201.78,195,195.57c-.54-.31-.47-.85.15-1.21l7.93-4.58a2.36,2.36,0,0,1,2.11-.09l10.75,6.21c.54.31.47.85-.15,1.21l-7.94,4.58A2.33,2.33,0,0,1,205.71,201.78Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M205.22,189.73l46.74,27c.58.33.58.87,0,1.21l-8.09,4.67a2.35,2.35,0,0,1-2.1,0l-46.74-27Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M295.12,247.52l7.49,4.32c.44.26.39.7-.12,1l-3.25,1.87a1.9,1.9,0,0,1-1.73.07L290,250.46c-.45-.25-.39-.7.12-1l3.25-1.88A1.94,1.94,0,0,1,295.12,247.52Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M284.66,241.48l7.48,4.32c.45.26.39.7-.12,1l-3.25,1.87a1.88,1.88,0,0,1-1.72.07l-7.49-4.32c-.44-.26-.39-.7.12-1l3.25-1.87A1.9,1.9,0,0,1,284.66,241.48Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M274.28,235.49l7.48,4.32c.45.25.39.7-.12,1l-3.25,1.88a1.94,1.94,0,0,1-1.72.07l-7.49-4.32c-.44-.26-.39-.7.12-1l3.25-1.87A1.9,1.9,0,0,1,274.28,235.49Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M290.39,238.17l7.49,4.32c.44.26.38.7-.13,1l-3.24,1.87a1.9,1.9,0,0,1-1.73.07l-7.49-4.32c-.44-.26-.38-.7.13-1l3.24-1.87A1.93,1.93,0,0,1,290.39,238.17Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "331.39 121.23 275.48 88.95 276.2 85.31 332.11 117.6 331.39 121.23"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "311.37 127.36 272.34 104.83 273.06 101.2 312.08 123.73 311.37 127.36"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "307.67 116.39 273.91 96.89 274.63 93.26 308.39 112.75 307.67 116.39"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "329.82 129.17 312.94 119.42 313.66 115.79 330.54 125.54 329.82 129.17"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "269.52 57.24 252.64 47.49 253.36 43.85 270.24 53.6 269.52 57.24"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "267.69 65.69 250.81 55.94 251.53 52.3 268.41 62.05 267.69 65.69"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "350.55 182.85 333.67 173.1 334.39 169.47 351.27 179.22 350.55 182.85"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "264.03 82.58 247.15 72.83 247.87 69.2 264.75 78.94 264.03 82.58"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M300.51,85.2a2.11,2.11,0,0,1-3,.93,2.65,2.65,0,0,1-1.09-3.31,2.11,2.11,0,0,1,3-.94A2.66,2.66,0,0,1,300.51,85.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M307.78,89.39a2.11,2.11,0,0,1-3,.94A2.66,2.66,0,0,1,303.65,87a2.11,2.11,0,0,1,3-.93A2.64,2.64,0,0,1,307.78,89.39Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M315.05,93.59a2.11,2.11,0,0,1-3,.94,2.65,2.65,0,0,1-1.08-3.32,2.1,2.1,0,0,1,3-.93A2.64,2.64,0,0,1,315.05,93.59Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M322.32,97.79a2.11,2.11,0,0,1-3,.94,2.65,2.65,0,0,1-1.09-3.32,2.1,2.1,0,0,1,3-.93A2.63,2.63,0,0,1,322.32,97.79Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M201.45,249.09,155.1,222.33c-1.34-.78-1.18-2.14.38-3l28-16.14a5.86,5.86,0,0,1,5.27-.22l46.34,26.76c1.35.78,1.18,2.14-.37,3l-28,16.14A5.86,5.86,0,0,1,201.45,249.09Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-10"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-11"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M302,128.58c3.19,1.84,3.19,4.84,0,6.68L247.77,166.6a3.56,3.56,0,0,1-3.18,0,1,1,0,0,1,0-1.84l54.27-31.33c1.44-.83,1.44-2.19,0-3l-5.26-3c.58-.88,1.11-1.8,1.63-2.73Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M225.17,153.55l54.27-31.33a12.86,12.86,0,0,1,11.59,0l4.2,2.43c-.52.93-1.05,1.85-1.63,2.73l-5.75-3.33a5.8,5.8,0,0,0-5.23,0l-54.27,31.34a3.5,3.5,0,0,1-3.18,0A1,1,0,0,1,225.17,153.55Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-8",
    points: "224.52 154.54 224.51 78.22 281.39 46.52 289.34 45.99 297.03 50.97 301.75 55.08 246.34 142.95 228.25 153.62 224.52 154.54"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-12",
    points: "245.55 164.17 228.55 154.36 228.55 80.61 246.08 88.75 245.55 164.17"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "304.43 55.67 304.43 131.86 244.73 166.01 243.93 165.69 243.93 89.39 304.43 55.67"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M270.85,56.3l11.87-6.81a5.81,5.81,0,0,1,4.91.14l11,6.36a1.68,1.68,0,0,1,1,1.81l-30,17.92L245.61,90.5l-17.06-9.89Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M246.08,88.19V167a3.13,3.13,0,0,1-1.49-.37,1.15,1.15,0,0,1-.66-.9h0V89.39Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "224.51 79.17 224.51 78.22 224.82 78.22 224.91 78.87 224.51 79.17"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "243.93 90.38 243.93 89.41 244.22 89.82 243.93 90.38"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M247.77,90.3,302,59c3.19-1.84,3.19-4.84,0-6.68l-11-6.36a12.8,12.8,0,0,0-11.59,0L225.17,77.25a1,1,0,0,0,0,1.84,3.56,3.56,0,0,0,3.18,0l54.27-31.34a5.8,5.8,0,0,1,5.23,0l11,6.36c1.44.83,1.44,2.19,0,3L244.59,88.46a1,1,0,0,0,0,1.84A3.56,3.56,0,0,0,247.77,90.3Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "261.91 126.42 290.11 110.14 290.11 81.86 261.91 98.15 261.91 126.42"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M225.17,79.09a3.56,3.56,0,0,0,3.18,0l54.27-31.34a5.8,5.8,0,0,1,5.23,0l11,6.36c.94.55,1.26,1.31,1,2a2.1,2.1,0,0,0-1-1l-11-6.36a5.8,5.8,0,0,0-5.23,0L228.35,80.09a3.5,3.5,0,0,1-3.18,0c-.66-.38-.82-1-.48-1.42A1.68,1.68,0,0,0,225.17,79.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M244.59,90.3a3.56,3.56,0,0,0,3.18,0L302,59a4.37,4.37,0,0,0,2.34-2.84c.25,1.37-.52,2.8-2.34,3.85L247.77,91.3a3.5,3.5,0,0,1-3.18,0c-.67-.38-.83-1-.48-1.42A1.56,1.56,0,0,0,244.59,90.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M327,143.35c3.19,1.84,3.19,4.84,0,6.69l-54.27,31.33a3.5,3.5,0,0,1-3.18,0,1,1,0,0,1,0-1.84l54.27-31.33c1.44-.83,1.44-2.18,0-3l-5.26-3c.59-.88,1.12-1.8,1.63-2.73Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M250.12,168.33,304.4,137A12.84,12.84,0,0,1,316,137l4.2,2.43c-.51.93-1,1.85-1.63,2.73l-5.75-3.32a5.8,5.8,0,0,0-5.23,0L253.3,170.16a3.5,3.5,0,0,1-3.18,0A1,1,0,0,1,250.12,168.33Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "249.47 169.31 249.47 92.99 306.34 61.29 314.29 60.76 321.98 65.75 326.7 69.85 271.29 157.73 253.2 168.39 249.47 169.31"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-14",
    points: "270.5 178.95 253.5 169.13 253.5 95.38 271.03 103.52 270.5 178.95"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "329.38 70.44 329.38 146.63 269.68 180.79 268.88 180.47 268.88 104.16 329.38 70.44"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M295.8,71.07l11.87-6.81a5.85,5.85,0,0,1,4.91.14l11,6.36c.85.5,1.2,1.17,1,1.81l-30,17.92-24.09,14.78L253.5,95.38Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M271,103v78.77a3.13,3.13,0,0,1-1.49-.37,1.13,1.13,0,0,1-.66-.9h0v0h0V104.16Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "249.47 93.94 249.47 92.99 249.77 92.99 249.86 93.64 249.47 93.94"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "268.88 105.15 268.88 104.18 269.18 104.59 268.88 105.15"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M272.72,105.07,327,73.73c3.19-1.84,3.19-4.84,0-6.68l-11-6.36a12.84,12.84,0,0,0-11.58,0L250.12,92a1,1,0,0,0,0,1.84,3.5,3.5,0,0,0,3.18,0l54.27-31.33a5.74,5.74,0,0,1,5.23,0l11,6.35c1.44.83,1.44,2.19,0,3l-54.27,31.33a1,1,0,0,0,0,1.84A3.56,3.56,0,0,0,272.72,105.07Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "286.86 141.19 315.06 124.91 315.06 96.64 286.86 112.92 286.86 141.19"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M250.12,93.86a3.5,3.5,0,0,0,3.18,0l54.27-31.33a5.74,5.74,0,0,1,5.23,0l11,6.35c.94.55,1.26,1.32,1,2a2.19,2.19,0,0,0-1-1l-11-6.36a5.8,5.8,0,0,0-5.23,0L253.3,94.86a3.5,3.5,0,0,1-3.18,0c-.66-.38-.82-.94-.48-1.42A1.54,1.54,0,0,0,250.12,93.86Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M269.54,105.07a3.56,3.56,0,0,0,3.18,0L327,73.73a4.37,4.37,0,0,0,2.34-2.84c.26,1.38-.52,2.8-2.34,3.85l-54.27,31.33a3.5,3.5,0,0,1-3.18,0c-.67-.38-.83-.95-.48-1.42A1.54,1.54,0,0,0,269.54,105.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M352.63,159.14c3.19,1.84,3.19,4.84,0,6.68l-54.27,31.34a3.56,3.56,0,0,1-3.18,0,1,1,0,0,1,0-1.84L349.45,164c1.44-.83,1.44-2.19,0-3l-5.26-3c.58-.88,1.11-1.8,1.63-2.73Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M275.76,184.11,330,152.78a12.84,12.84,0,0,1,11.58,0l4.21,2.43c-.52.93-1.05,1.85-1.63,2.73l-5.75-3.33a5.8,5.8,0,0,0-5.23,0L278.94,186a3.56,3.56,0,0,1-3.18,0A1,1,0,0,1,275.76,184.11Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-8",
    points: "275.11 185.1 275.1 108.78 331.98 77.08 339.93 76.55 347.62 81.53 352.34 85.64 296.93 173.51 278.84 184.18 275.11 185.1"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-12",
    points: "296.14 194.73 279.14 184.92 279.14 111.17 296.67 119.31 296.14 194.73"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "355.02 86.23 355.02 162.42 295.32 196.57 294.52 196.25 294.52 119.95 355.02 86.23"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M321.44,86.86,333.31,80a5.85,5.85,0,0,1,4.91.15l11,6.36a1.68,1.68,0,0,1,1,1.81l-30,17.92L296.2,121.06l-17.06-9.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M296.67,118.75v78.78a3.13,3.13,0,0,1-1.49-.37,1.15,1.15,0,0,1-.66-.9h0V120Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "275.1 109.73 275.1 108.78 275.41 108.78 275.5 109.43 275.1 109.73"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "294.52 120.94 294.52 119.97 294.81 120.38 294.52 120.94"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M298.36,120.86l54.27-31.34c3.19-1.84,3.19-4.84,0-6.68l-11-6.36a12.77,12.77,0,0,0-11.58,0l-54.27,31.33a1,1,0,0,0,0,1.84,3.56,3.56,0,0,0,3.18,0l54.27-31.34a5.8,5.8,0,0,1,5.23,0l11,6.36c1.44.83,1.44,2.18,0,3L295.18,119a1,1,0,0,0,0,1.84A3.56,3.56,0,0,0,298.36,120.86Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "312.5 156.98 340.7 140.69 340.7 112.42 312.5 128.71 312.5 156.98"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M275.76,109.65a3.56,3.56,0,0,0,3.18,0l54.27-31.34a5.8,5.8,0,0,1,5.23,0l11,6.36c.94.55,1.26,1.31,1,2a2.1,2.1,0,0,0-1-1l-11-6.36a5.8,5.8,0,0,0-5.23,0l-54.27,31.33a3.5,3.5,0,0,1-3.18,0c-.66-.38-.82-1-.48-1.42A1.68,1.68,0,0,0,275.76,109.65Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M295.18,120.86a3.56,3.56,0,0,0,3.18,0l54.27-31.34A4.37,4.37,0,0,0,355,86.68c.25,1.37-.52,2.8-2.34,3.85l-54.27,31.33a3.5,3.5,0,0,1-3.18,0c-.67-.38-.83-1-.48-1.42A1.56,1.56,0,0,0,295.18,120.86Z"
  }))), /*#__PURE__*/React.createElement("g", {
    className: "cls-15"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M302,128.58c3.19,1.84,3.19,4.84,0,6.68L247.77,166.6a3.56,3.56,0,0,1-3.18,0,1,1,0,0,1,0-1.84l54.27-31.33c1.44-.83,1.44-2.19,0-3l-5.26-3c.58-.88,1.11-1.8,1.63-2.73Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M225.17,153.55l54.27-31.33a12.86,12.86,0,0,1,11.59,0l4.2,2.43c-.52.93-1.05,1.85-1.63,2.73l-5.75-3.33a5.8,5.8,0,0,0-5.23,0l-54.27,31.34a3.5,3.5,0,0,1-3.18,0A1,1,0,0,1,225.17,153.55Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-8",
    points: "224.52 154.54 224.51 78.22 281.39 46.52 289.34 45.99 297.03 50.97 301.75 55.08 246.34 142.95 228.25 153.62 224.52 154.54"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-12",
    points: "245.55 164.17 228.55 154.36 228.55 80.61 246.08 88.75 245.55 164.17"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "304.43 55.67 304.43 131.86 244.73 166.01 243.93 165.69 243.93 89.39 304.43 55.67"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M270.85,56.3l11.87-6.81a5.81,5.81,0,0,1,4.91.14l11,6.36a1.68,1.68,0,0,1,1,1.81l-30,17.92L245.61,90.5l-17.06-9.89Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M246.08,88.19V167a3.13,3.13,0,0,1-1.49-.37,1.15,1.15,0,0,1-.66-.9h0V89.39Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "224.51 79.17 224.51 78.22 224.82 78.22 224.91 78.87 224.51 79.17"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "243.93 90.38 243.93 89.41 244.22 89.82 243.93 90.38"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M247.77,90.3,302,59c3.19-1.84,3.19-4.84,0-6.68l-11-6.36a12.8,12.8,0,0,0-11.59,0L225.17,77.25a1,1,0,0,0,0,1.84,3.56,3.56,0,0,0,3.18,0l54.27-31.34a5.8,5.8,0,0,1,5.23,0l11,6.36c1.44.83,1.44,2.19,0,3L244.59,88.46a1,1,0,0,0,0,1.84A3.56,3.56,0,0,0,247.77,90.3Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "261.91 126.42 290.11 110.14 290.11 81.86 261.91 98.15 261.91 126.42"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M225.17,79.09a3.56,3.56,0,0,0,3.18,0l54.27-31.34a5.8,5.8,0,0,1,5.23,0l11,6.36c.94.55,1.26,1.31,1,2a2.1,2.1,0,0,0-1-1l-11-6.36a5.8,5.8,0,0,0-5.23,0L228.35,80.09a3.5,3.5,0,0,1-3.18,0c-.66-.38-.82-1-.48-1.42A1.68,1.68,0,0,0,225.17,79.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M244.59,90.3a3.56,3.56,0,0,0,3.18,0L302,59a4.37,4.37,0,0,0,2.34-2.84c.25,1.37-.52,2.8-2.34,3.85L247.77,91.3a3.5,3.5,0,0,1-3.18,0c-.67-.38-.83-1-.48-1.42A1.56,1.56,0,0,0,244.59,90.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M327,143.35c3.19,1.84,3.19,4.84,0,6.69l-54.27,31.33a3.5,3.5,0,0,1-3.18,0,1,1,0,0,1,0-1.84l54.27-31.33c1.44-.83,1.44-2.18,0-3l-5.26-3c.59-.88,1.12-1.8,1.63-2.73Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M250.12,168.33,304.4,137A12.84,12.84,0,0,1,316,137l4.2,2.43c-.51.93-1,1.85-1.63,2.73l-5.75-3.32a5.8,5.8,0,0,0-5.23,0L253.3,170.16a3.5,3.5,0,0,1-3.18,0A1,1,0,0,1,250.12,168.33Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "249.47 169.31 249.47 92.99 306.34 61.29 314.29 60.76 321.98 65.75 326.7 69.85 271.29 157.73 253.2 168.39 249.47 169.31"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-14",
    points: "270.5 178.95 253.5 169.13 253.5 95.38 271.03 103.52 270.5 178.95"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "329.38 70.44 329.38 146.63 269.68 180.79 268.88 180.47 268.88 104.16 329.38 70.44"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M295.8,71.07l11.87-6.81a5.85,5.85,0,0,1,4.91.14l11,6.36c.85.5,1.2,1.17,1,1.81l-30,17.92-24.09,14.78L253.5,95.38Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M271,103v78.77a3.13,3.13,0,0,1-1.49-.37,1.13,1.13,0,0,1-.66-.9h0v0h0V104.16Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "249.47 93.94 249.47 92.99 249.77 92.99 249.86 93.64 249.47 93.94"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "268.88 105.15 268.88 104.18 269.18 104.59 268.88 105.15"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M272.72,105.07,327,73.73c3.19-1.84,3.19-4.84,0-6.68l-11-6.36a12.84,12.84,0,0,0-11.58,0L250.12,92a1,1,0,0,0,0,1.84,3.5,3.5,0,0,0,3.18,0l54.27-31.33a5.74,5.74,0,0,1,5.23,0l11,6.35c1.44.83,1.44,2.19,0,3l-54.27,31.33a1,1,0,0,0,0,1.84A3.56,3.56,0,0,0,272.72,105.07Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "286.86 141.19 315.06 124.91 315.06 96.64 286.86 112.92 286.86 141.19"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M250.12,93.86a3.5,3.5,0,0,0,3.18,0l54.27-31.33a5.74,5.74,0,0,1,5.23,0l11,6.35c.94.55,1.26,1.32,1,2a2.19,2.19,0,0,0-1-1l-11-6.36a5.8,5.8,0,0,0-5.23,0L253.3,94.86a3.5,3.5,0,0,1-3.18,0c-.66-.38-.82-.94-.48-1.42A1.54,1.54,0,0,0,250.12,93.86Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M269.54,105.07a3.56,3.56,0,0,0,3.18,0L327,73.73a4.37,4.37,0,0,0,2.34-2.84c.26,1.38-.52,2.8-2.34,3.85l-54.27,31.33a3.5,3.5,0,0,1-3.18,0c-.67-.38-.83-.95-.48-1.42A1.54,1.54,0,0,0,269.54,105.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M352.63,159.14c3.19,1.84,3.19,4.84,0,6.68l-54.27,31.34a3.56,3.56,0,0,1-3.18,0,1,1,0,0,1,0-1.84L349.45,164c1.44-.83,1.44-2.19,0-3l-5.26-3c.58-.88,1.11-1.8,1.63-2.73Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M275.76,184.11,330,152.78a12.84,12.84,0,0,1,11.58,0l4.21,2.43c-.52.93-1.05,1.85-1.63,2.73l-5.75-3.33a5.8,5.8,0,0,0-5.23,0L278.94,186a3.56,3.56,0,0,1-3.18,0A1,1,0,0,1,275.76,184.11Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-8",
    points: "275.11 185.1 275.1 108.78 331.98 77.08 339.93 76.55 347.62 81.53 352.34 85.64 296.93 173.51 278.84 184.18 275.11 185.1"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-12",
    points: "296.14 194.73 279.14 184.92 279.14 111.17 296.67 119.31 296.14 194.73"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "355.02 86.23 355.02 162.42 295.32 196.57 294.52 196.25 294.52 119.95 355.02 86.23"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M321.44,86.86,333.31,80a5.85,5.85,0,0,1,4.91.15l11,6.36a1.68,1.68,0,0,1,1,1.81l-30,17.92L296.2,121.06l-17.06-9.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M296.67,118.75v78.78a3.13,3.13,0,0,1-1.49-.37,1.15,1.15,0,0,1-.66-.9h0V120Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "275.1 109.73 275.1 108.78 275.41 108.78 275.5 109.43 275.1 109.73"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "294.52 120.94 294.52 119.97 294.81 120.38 294.52 120.94"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M298.36,120.86l54.27-31.34c3.19-1.84,3.19-4.84,0-6.68l-11-6.36a12.77,12.77,0,0,0-11.58,0l-54.27,31.33a1,1,0,0,0,0,1.84,3.56,3.56,0,0,0,3.18,0l54.27-31.34a5.8,5.8,0,0,1,5.23,0l11,6.36c1.44.83,1.44,2.18,0,3L295.18,119a1,1,0,0,0,0,1.84A3.56,3.56,0,0,0,298.36,120.86Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "312.5 156.98 340.7 140.69 340.7 112.42 312.5 128.71 312.5 156.98"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M275.76,109.65a3.56,3.56,0,0,0,3.18,0l54.27-31.34a5.8,5.8,0,0,1,5.23,0l11,6.36c.94.55,1.26,1.31,1,2a2.1,2.1,0,0,0-1-1l-11-6.36a5.8,5.8,0,0,0-5.23,0l-54.27,31.33a3.5,3.5,0,0,1-3.18,0c-.66-.38-.82-1-.48-1.42A1.68,1.68,0,0,0,275.76,109.65Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M295.18,120.86a3.56,3.56,0,0,0,3.18,0l54.27-31.34A4.37,4.37,0,0,0,355,86.68c.25,1.37-.52,2.8-2.34,3.85l-54.27,31.33a3.5,3.5,0,0,1-3.18,0c-.67-.38-.83-1-.48-1.42A1.56,1.56,0,0,0,295.18,120.86Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M375.8,281.66a8.64,8.64,0,0,0-7.77,0l-100.25,57.9c-2.14,1.24-2.14,3.25,0,4.49a8.6,8.6,0,0,0,7.78,0l100.24-57.9C377.94,284.91,377.94,282.9,375.8,281.66Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M392.93,250.3h0a.44.44,0,0,0-.47-.2l-6.07,1.31,2.39,4.06,4.1-4.66A.45.45,0,0,0,392.93,250.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M390.54,253.3a3,3,0,0,0-1.39-2.37,1,1,0,0,0-.91-.11,38.7,38.7,0,0,0-19.94,5.34l-.44.26,7.53,12.81,2.23-1.47a38.88,38.88,0,0,0,11.62-12.06l.95-1.55A1,1,0,0,0,390.54,253.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M376.9,265.82a11.6,11.6,0,0,0-5.32-9.06c-2.92-1.66-5.26-.28-5.23,3.07a11.6,11.6,0,0,0,5.32,9.06C374.59,270.54,376.93,269.17,376.9,265.82Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "330.69 297.08 375.39 269.23 367.86 256.42 321.79 281.94 330.69 297.08"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M332.48,293a13.73,13.73,0,0,0-6.29-10.7C322.74,280.39,320,282,320,286a13.73,13.73,0,0,0,6.3,10.71C329.74,298.63,332.51,297,332.48,293Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M329.93,294.54a13.72,13.72,0,0,0-6.29-10.7c-3.45-2-6.22-.33-6.19,3.63a13.73,13.73,0,0,0,6.3,10.71C327.19,300.13,330,298.5,329.93,294.54Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 259.82,
    y: 299.61,
    width: 68.6,
    height: 17.56,
    transform: "translate(-115.71 191.57) rotate(-30.45)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M270.79,329.3a13.73,13.73,0,0,0-6.29-10.7c-3.45-2-6.21-.33-6.18,3.63a13.72,13.72,0,0,0,6.29,10.71C268.05,334.89,270.82,333.26,270.79,329.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M268.56,328a9.07,9.07,0,0,0-4.25-6.5c-2.22-1.26-3.9-.38-3.76,2a9,9,0,0,0,4.25,6.5C267,331.25,268.69,330.38,268.56,328Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M332.93,292.78a13.73,13.73,0,0,0-6.3-10.71,4.89,4.89,0,0,0-3.69-.69c1.12-1.16,3-1.3,5-.12a13.72,13.72,0,0,1,6.3,10.71c0,2.36-1,3.89-2.49,4.32A5,5,0,0,0,332.93,292.78Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M332.93,292.78a13.73,13.73,0,0,0-6.3-10.71c-1.72-1-3.27-1.05-4.39-.4l-3.35,2,1.6,2.72a14,14,0,0,0,5.7,9.71l1.6,2.71,3.35-2h0C332.26,296.16,332.94,294.76,332.93,292.78Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M329.58,294.75a13.73,13.73,0,0,0-6.3-10.71c-3.44-2-6.21-.32-6.18,3.64a13.7,13.7,0,0,0,6.3,10.7C326.84,300.34,329.61,298.71,329.58,294.75Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M265.77,329.8l-3.84-6.54-12.53,7.37a3.8,3.8,0,0,0-1.35,5.19h0a3.8,3.8,0,0,0,5.19,1.34Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M266.55,328.06a5.93,5.93,0,0,0-2.72-4.62c-1.49-.85-2.68-.14-2.67,1.56a5.93,5.93,0,0,0,2.72,4.62C265.36,330.47,266.56,329.76,266.55,328.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M280.48,305l-1.88-1.07a4,4,0,0,0-4,.43l-6.44,3.79A4.89,4.89,0,0,0,266,312l0,3.23a2.73,2.73,0,0,1-.65,1.62l.24,1.49-1.61-.92h0a.83.83,0,0,1-.39-.79l0-3.22a10.22,10.22,0,0,1,4.55-8l6.45-3.78c2.15-1.27,4.18-1.49,5.71-.62l1.88,1.07a4,4,0,0,0,4-.43l26-15.26a.83.83,0,0,1,.86-.08h0l1.6.92-1.37.53a2.62,2.62,0,0,1-1.07,1.41l-26,15.27C284,305.65,282,305.87,280.48,305Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M280.22,304.86c-1.08-.61-2.5-.46-4,.43l-6.44,3.79a4.9,4.9,0,0,0-2.18,3.85l0,3.23a2.65,2.65,0,0,1-1.18,2.09c-.66.39-1.2.08-1.21-.69l0-3.22a10.26,10.26,0,0,1,4.56-8l6.44-3.78c2.15-1.27,4.19-1.48,5.72-.61l1.88,1.06a4,4,0,0,0,4-.43l26-15.26c.66-.39,1.2-.08,1.2.68a2.66,2.66,0,0,1-1.18,2.1l-26,15.26c-2.15,1.26-4.18,1.48-5.72.61Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M267.5,313.47l0,3.22s0,0,0,.06a2.06,2.06,0,0,0,.09-.59l0-3.23c0-.09,0-.18,0-.28A3.34,3.34,0,0,0,267.5,313.47Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-2",
    cx: 245,
    cy: 250.18,
    rx: 20.39,
    ry: 11.77
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M268.19,240.11V233.6H267a14.75,14.75,0,0,0-5.56-5.2c-9.06-5.23-23.75-5.23-32.8,0a14.79,14.79,0,0,0-5.57,5.2h-1.22v6.48h0c0,3.43,2.24,6.88,6.79,9.5,9.05,5.23,23.74,5.23,32.8,0C265.93,247,268.19,243.54,268.19,240.11Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-9",
    cx: 245,
    cy: 233.6,
    rx: 23.19,
    ry: 13.39
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M261.4,243.07c-9.06,5.23-23.75,5.23-32.8,0-4.34-2.51-6.58-5.76-6.76-9-.2,3.57,2,7.18,6.76,9.9,9.05,5.23,23.74,5.23,32.8,0,4.71-2.72,7-6.33,6.75-9.89C268,237.31,265.74,240.56,261.4,243.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M233.82,238a1,1,0,0,1-.61-.85l0-8.73c0-.66.94-1.2,2.09-1.2s2.08.54,2.08,1.21l0,7.23,21-2.57c1.13-.14,2.24.28,2.48.93s-.49,1.29-1.61,1.43l-23.52,2.88a3.36,3.36,0,0,1-1.75-.24Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "125.13 165.99 107.9 156.04 125.13 146.09 142.36 156.04 125.13 165.99"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "142.36 143.41 125.13 153.36 125.13 133.46 142.36 123.52 142.36 143.41"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "125.13 133.46 107.9 123.52 125.13 113.57 142.36 123.52 125.13 133.46"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "125.13 153.36 107.9 143.41 107.9 123.52 125.13 133.46 125.13 153.36"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "118.93 142.61 114.11 139.83 114.11 134.26 118.93 137.04 118.93 142.61"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "17.94 344.36 0 334 17.94 323.65 35.88 334 17.94 344.36"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "35.88 320.86 17.94 331.21 17.94 310.5 35.88 300.14 35.88 320.86"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "17.94 310.5 0 300.14 17.94 289.79 35.88 300.14 17.94 310.5"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-8",
    points: "17.94 331.21 0 320.86 0 300.14 17.94 310.5 17.94 331.21"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "11.48 320.02 6.46 317.13 6.46 311.33 11.48 314.23 11.48 320.02"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M83.18,320.19,16.33,281.6a2.26,2.26,0,0,1,0-3.91L79.9,241,151,282.06a2.25,2.25,0,0,1,0,3.9L91.72,320.19A8.52,8.52,0,0,1,83.18,320.19Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M81.25,214.24c0-4.24-3-6-6.66-3.85l-62.52,36a4,4,0,0,0-1.83,3.17c0,1.16.81,1.64,1.83,1.06l62.52-36c1.66-1,3-.17,3,1.74v7c1.21-.07,2.43-.07,3.66-.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M12,263.21l62.52-22.78a14.75,14.75,0,0,0,6.68-11.55v-5.59c-1.23,0-2.45,0-3.66.05V231a6.65,6.65,0,0,1-3,5.21L12.05,259a4,4,0,0,0-1.84,3.17C10.21,263.32,11,263.79,12,263.21Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "10.69 263.29 86.74 307.3 151.13 268.9 156.24 261.27 155.71 263.98 154.34 256.9 34.81 261.46 13.75 260.11 10.69 263.29"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-14",
    points: "13.21 250.01 13.19 259.37 86.69 301.9 88.68 292.98 13.21 250.01"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "155.29 253.89 79.36 209.96 10.9 249.78 10.76 250.75 86.8 294.75 155.29 253.89"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M131.09,276.45l17.85-10.59a6.69,6.69,0,0,0,2.68-5l0-1.4a2,2,0,0,0-1.21-2.08L115.29,277,86.67,292.43l0,9.47Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M89.23,293.3,13.78,249.65l-1.6-.93-1.46-.84a3.62,3.62,0,0,0-.48,1.7,1.3,1.3,0,0,0,.52,1.17h0l76,44Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "85.79 306.75 86.74 307.3 86.92 307 86.33 306.53 85.79 306.75"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "85.82 294.18 86.79 294.74 86.55 294.21 85.82 294.18"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M88.11,290.4l62.52-36c3.68-2.12,6.67-.39,6.67,3.86l0,1.4a14.74,14.74,0,0,1-6.67,11.54l-62.52,36c-1,.59-1.83.11-1.83-1.06A4,4,0,0,1,88.09,303l62.52-36a6.63,6.63,0,0,0,3-5.2l0-1.4c0-1.92-1.35-2.7-3-1.74l-62.52,36c-1,.58-1.83.11-1.83-1.06A4.05,4.05,0,0,1,88.11,290.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M86.26,306.14A4,4,0,0,1,88.09,303l62.52-36a6.63,6.63,0,0,0,3-5.2l0-1.4c0-1.26-.58-2-1.45-2.13a2.51,2.51,0,0,1,.44,1.55v1.4a6.63,6.63,0,0,1-3,5.2l-62.52,36a4,4,0,0,0-1.83,3.16c0,.89.47,1.37,1.13,1.3A1.85,1.85,0,0,1,86.26,306.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M86.28,293.57a4.05,4.05,0,0,1,1.83-3.17l62.52-36a5.06,5.06,0,0,1,4.19-.7c-1.23-1-3.09-1.08-5.19.12l-62.52,36A4.07,4.07,0,0,0,85.28,293c0,.89.47,1.37,1.14,1.3A1.74,1.74,0,0,1,86.28,293.57Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "57.37 254.76 91.86 234.88 121.78 252.19 87.28 272.07 57.37 254.76"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M142.67,350.88c13.81,8,36.2,8,50,0s13.81-20.9,0-28.87-36.2-8-50,0S128.86,342.91,142.67,350.88Zm13.51-21.07c6.35-3.66,16.64-3.66,23,0s6.35,9.61,0,13.27-16.64,3.67-23,0S149.84,333.48,156.18,329.81Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M197.9,317.29l-12.62.19a13.41,13.41,0,0,0-4-3.35c-6.94-4-17.84-4.31-25.4-.93l-7.5-7.05-11.54.18c.57-.37,1.16-.74,1.78-1.1,16-9.26,42-9.26,58.08,0a30.55,30.55,0,0,1,7.22,5.62Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "136.86 288.01 136.86 306.33 148.4 306.15 148.4 287.83 136.86 288.01"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-16",
    points: "155.9 294.88 155.9 313.2 148.4 306.15 148.4 287.83 155.9 294.88"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M185.28,299.17v18.31L168.69,304,155.9,313.2V294.88l11.78-5.71s16.21,5,17.06,5.17S185.28,299.17,185.28,299.17Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-16",
    points: "197.9 298.97 197.9 317.29 185.28 317.48 185.28 299.17 197.9 298.97"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "203.94 292.54 203.94 310.85 197.9 317.29 197.9 298.97 203.94 292.54"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M197.9,299l-12.62.2a13.12,13.12,0,0,0-4-3.35c-6.94-4-17.84-4.32-25.4-.94l-7.5-7.05-11.54.18c.57-.37,1.16-.74,1.78-1.1,16-9.26,42-9.26,58.08,0a30.83,30.83,0,0,1,7.22,5.63Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M152.1,297.14V314l-10.92-2.61s.64-9.86.87-10.12S152.1,297.14,152.1,297.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M160.36,314v18.32l-1.18,1.26-7.69-4.44s1.19-14,1.33-14.26S160.36,314,160.36,314Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M145.5,309.25l6.6,6.2c-5.5,4.35-4.85,10.49,2,14.41a23.38,23.38,0,0,0,6.31,2.43l-6.82,7.27,6.05,5.69a55.06,55.06,0,0,1-21-6.48c-13.79-8-15.72-20.17-5.8-29.33Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "159.59 326.93 159.59 345.25 144.62 339.47 126.61 322.29 126.68 302.84 145.73 317.94 159.59 326.93"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M145.5,290.93l6.6,6.21c-5.5,4.35-4.85,10.48,2,14.41a23.7,23.7,0,0,0,6.31,2.42l-6.82,7.27,6.05,5.69a55.06,55.06,0,0,1-21-6.48c-13.79-8-15.72-20.17-5.8-29.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M159.63,339.47l6-6.41c5.58.34,11.37-.72,15.65-3.2s6.24-6,5.47-9.35l14.32-.22,5.51-5.87c4.81,8.27,1.53,17.76-9.88,24.35-8.38,4.84-19.48,7.14-30.46,6.92Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "166.25 327.37 166.25 345.69 208.74 322.15 208.74 303.82 202.54 306.33 166.25 327.37"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "159.63 321.15 159.63 339.47 166.25 345.69 166.25 327.37 159.63 321.15"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M159.63,321.15l6-6.41c5.58.34,11.37-.72,15.65-3.19s6.24-6,5.47-9.36l14.32-.22,5.51-5.87c4.81,8.27,1.53,17.76-9.88,24.35-8.38,4.84-19.48,7.14-30.46,6.92Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmpty);
export default __webpack_public_path__ + "static/media/empty.5f342ba85a6b08b991b32fafe1ce5194.svg";
export { ForwardRef as ReactComponent };